<template>
  <div class="max-w-full flex flex-col items-end">
    <Card :customClasses="bubbleClasses" :ariaLabel="ariaLabel">
      <MessageBubbleBody :body="body" :bodyHtml="bodyHtml" />
    </Card>
    <MessageBubbleTimestamp :timestamp="timestamp" :isOutgoing="true" :read="read" :messageStatus="messageStatus" />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { MessageStatus } from '@/apps/messages/types';
import Card from '@/components/card/Card.vue';
import MessageBubbleBody from './MessageBubbleBody.vue';
import MessageBubbleTimestamp from './MessageBubbleTimestamp.vue';

const OUTGOING_BUBBLE_CLASSES = 'bg-safety-contrast text-white w-full px-12 py-10';

export default {
  name: 'MessageBubbleOutgoing',
  components: {
    Card,
    MessageBubbleBody,
    MessageBubbleTimestamp,
  },
  props: {
    body: {
      type: String,
      default: '',
    },
    bodyHtml: {
      type: String,
      default: '',
    },
    timestamp: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    read: {
      type: Boolean,
      default: false,
    },
    messageStatus: {
      type: String as PropType<MessageStatus>,
      default: 'sent',
    },
  },
  computed: {
    bubbleClasses(): string {
      return OUTGOING_BUBBLE_CLASSES;
    },
  },
};
</script>
